import { useInfiniteQuery } from '@tanstack/react-query';

import MerchandisingCollectionsService, {
  MerchandisingCollectionSlicesQueryFilterDto,
} from '@/services/MerchandisingCollectionsService';

export const MERCHANDISING_COLLECTION_SLICES_QUERY_KEY = [
  'merchandisingCollectionSlices',
];

export function useGetMerchandisingCollectionSlices(
  collectionId: number,
  queryFilter?: Partial<MerchandisingCollectionSlicesQueryFilterDto>,
) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [
        ...MERCHANDISING_COLLECTION_SLICES_QUERY_KEY,
        collectionId,
        queryFilter,
      ],
      initialPageParam: queryFilter?.page ?? 1,
      queryFn: ({ pageParam }) =>
        MerchandisingCollectionsService.findSlices(collectionId, {
          page: pageParam,
          limit: queryFilter?.limit ?? 10,
          name: queryFilter?.name,
          orderBy: queryFilter?.orderBy,
          orderDirection: queryFilter?.orderDirection,
        }),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const { currentPage, totalPages } = lastPage;

        if (currentPage === totalPages || totalPages === 0) {
          return null;
        }

        return lastPageParam + 1;
      },
    });

  const merchandisingCollectionSlices = data?.pages.flatMap(
    (page) => page?.items,
  );

  return {
    merchandisingCollectionSlices: merchandisingCollectionSlices ?? [],
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
